import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";

import type { FC } from "react";

export const ContentLibraryLoadingErrorModal: FC<{
  open: boolean;
  onClose: () => void;
}> = ({ open, onClose }) => (
  <Dialog open={open} onClose={onClose} maxWidth="md">
    <DialogTitle sx={{ my: 2 }}>Content Library - Error</DialogTitle>
    <DialogContent>
      <Alert severity="error">
        Sorry, there was a problem retrieving your content. Please try again later.
      </Alert>
    </DialogContent>
    <DialogActions>
      <Button data-analytics-id="editor-content-library-error-ok" type="button" onClick={onClose}>
        Ok
      </Button>
    </DialogActions>
  </Dialog>
);
